import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import {thStyles} from "./styles/Table.css";
import {SortOrder} from './../../../constants/Enums';

class TableHeader extends Component {

  constructor(props) {
    super(props);

    this.state = {
      sortOrder: SortOrder.DESCENDING,
      icon: "arrow_drop_down"
    };
  }


  render() {
    let style = thStyles({borderColor: this.props.borderColor, first: this.props.isFirstElement});

    let sort = () => {
      let sortOrder;
      let icon;
      if (this.state.sortOrder === SortOrder.DESCENDING) {
        sortOrder = SortOrder.ASCENDING;
        icon = "arrow_drop_up";
      }
      else {
        sortOrder = SortOrder.DESCENDING;
        icon = "arrow_drop_down";
      }
      this.props.sort(this.props.sortTarget, sortOrder);
      this.setState({
        sortOrder,
        icon
      });
    };

    return (
      <th style={style} onClick={() => sort()}>
        {this.props.title}
        <div className="float-right">
          <i className="material-icons">
            {this.state.icon}
          </i>
        </div>
      </th>
    );
  }

}
;

TableHeader.propTypes = {
  sort: PropTypes.func.isRequired,
  sortTarget: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  borderColor: PropTypes.string,
  isFirstElement: PropTypes.bool.isRequired
};

export default TableHeader;